const SPRITE_ID = 'pplx-icon-sprites';
export function embedSvg(svg, id = SPRITE_ID) {
    if (document.getElementById(id)) {
        return;
    }
    const div = document.createElement('div');
    div.id = id;
    div.innerHTML = svg;
    div.style.display = 'none';
    document.body.appendChild(div);
}
//# sourceMappingURL=embedSvg.js.map